import { computed, nextTick, onBeforeUnmount, onMounted, watch } from "vue";
import useStore from "../store.ts";
import { parsePx } from "../utils/ElementUtils.ts";
import { postDimensions } from "../worker/RenderWorkerManager.ts";

/* see docs/EXTRACTED_COMMENTS.md#c077 */
export function useLayoutScale(): { onResize: () => void } {
    const store = useStore();

    const statusBarVisible = computed(() => {
        if (store.disconnectPolicyDisplay.visible) return false;
        if (store.ui.statusBarAutoShown) return true;
        return store.ui.statusBarVisible;
    });

    const onResize = () => {
        nextTick(() => {
            if (Object.keys(store.layoutData).length === 0) return;
            const item = store.components[Object.keys(store.layoutData)[0].replace("_", "")];
            if (!item) return;
            const width = parsePx(item.style.width);
            const height = parsePx(item.style.height);
            const innerScale = Math.min(innerWidth / width, innerHeight / height);
            item.style.transformOrigin = 'left top';
            item.style.transform = `scale(${innerScale * 100.0}%)`;
            item.props.style.transform = `scale(${innerScale * 100.0}%)`;
            postDimensions();
        });
    };

    watch(statusBarVisible, onResize);
    watch(
        () => [store.ui.statusBarVisible, store.ui.statusBarAutoShown, store.disconnectPolicyDisplay.visible],
        onResize,
    );

    onMounted(() => {
        window.addEventListener('resize', onResize);
        window.addEventListener('fullscreenchange', onResize);
    });

    onBeforeUnmount(() => {
        window.removeEventListener('resize', onResize);
        window.removeEventListener('fullscreenchange', onResize);
    });

    return { onResize };
}
